import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {SwitchField} from "@/components/form/fields/SwitchField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface PagerDutyFormProps {
  serverErrors?: ServerErrors;
}

export const PagerDutyForm = ({serverErrors}: PagerDutyFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <div>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <InputField
            name="settings.service_key"
            label="Integration Key"
            required={true}
            tooltip="Listed on the Service's details page, Integrations tab."
            maxLength={32}
            autoFocus={true}
          />
        </div>
      </div>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <SwitchField
            name="settings.autoresolve"
            label="Auto-resolve Incident"
            tooltip="Automatically resolve incident once the check is back up."
          />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          Login to your PagerDuty account, and click <strong>Services</strong> from the <strong>Configuration</strong>{" "}
          menu.
        </div>
        <div className="p-2">
          For a <strong>New Service</strong>, click <strong>Configuration &rarr; Add New Service</strong>. Search for
          the Uptime.com service from the <strong>Integration Type</strong> menu and then enter an&nbsp;
          <strong>Integration Name</strong>. In the Incident Settings section, specify the&nbsp;
          <strong>Escalation Policy</strong>, <strong>Notification Urgency</strong>, and&nbsp;
          <strong>Incident Behavior</strong>. To save your integration, click&nbsp;
          <strong>Add Service</strong> or <strong>Add Integration</strong> and copy the&nbsp;
          <strong>Integration Key</strong>.
        </div>
        <div className="p-2">
          Paste the <strong>Integration Key</strong> copied previously into the &quot;Integration Key&quot; field above.
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/360002179859-Configuring-PagerDuty">
            View {IntegrationModuleInfo[IntegrationModules.PAGERDUTY].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </div>
  );
};
